import { api } from '../../../api.js';
import type {
  AdvisorDoc,
  AdvisorVersion,
  AdvisorVersionMeta,
  ClientAdvisorStatus,
  ClientAdvisorSummaryAdmin,
} from '@agio/core/domain';

const client = (id: string) => `/admin/advisor-summary/clients/${encodeURIComponent(id)}`;

/** The admin side of סקירת יועץ. Every call returns the fresh state, so screens never guess. */
export const advisor = {
  versions: () => api.get<AdvisorVersionMeta[]>('/admin/advisor-summary/versions'),
  version: (n: number) => api.get<AdvisorVersion>(`/admin/advisor-summary/versions/${n}`),
  saveVersion: (body: AdvisorDoc) => api.post<AdvisorVersion>('/admin/advisor-summary/versions', { body }),

  statuses: () => api.get<ClientAdvisorStatus[]>('/admin/advisor-summary/clients'),
  summary: (id: string) => api.get<ClientAdvisorSummaryAdmin>(client(id)),
  copy: (id: string, version: number) => api.post<ClientAdvisorSummaryAdmin>(`${client(id)}/copy`, { version }),
  saveDraft: (id: string, body: AdvisorDoc) => api.put<ClientAdvisorSummaryAdmin>(`${client(id)}/draft`, { body }),
  publish: (id: string) => api.post<ClientAdvisorSummaryAdmin>(`${client(id)}/publish`, {}),
  reset: (id: string) => api.post<ClientAdvisorSummaryAdmin>(`${client(id)}/reset`, {}),
  undoPublish: (id: string) => api.post<ClientAdvisorSummaryAdmin>(`${client(id)}/undo-publish`, {}),
};

export function fmtWhen(iso: string | null): string {
  return iso ? new Date(iso).toLocaleString('he-IL', { dateStyle: 'short', timeStyle: 'short' }) : '—';
}
